// extracted by css-extract-rspack-plugin
export default {"root":"DetrO","message":"NfrYf","icon":"FRmuM"};